export default __webpack_public_path__ + "static/media/red_pdf.3bb1d85d.svg";